export const AUTH_ROUTES = {
  LOGIN: '/',
  FORGOT_PASSWORD: '/forgot-password',
  REGISTER: '/signup',
  USER_SEND_AUTHENTICATION_TOKEN: '/verify-user',
  USER_VERIFY_AUTHENTICATION_TOKEN: '/verify-token',
  AUTH: '/Auth',
} as const;

export const APP_ROUTES = {
  HOME: '/',
  USER_PROFILE_PERSONAL: '/user/personal',
  USER_PROFILE_PASSWORD: '/user/password',
  USER_PROFILE_THEME: '/user/theme',
  DASHBOARD: '/dashboard',
  CarrQuoteDashboard: '/CarrQuoteDashboard',
  CARRIER_REGISTRATION: '/CarrierRegistration',
  SHIPMENT: '/shipment',
  SHIPMENT_SEARCH_QUOTE: '/shipment/search-quote',
  SEARCH_QUOTE: '/search-quote',
  SEARCH_QUOTE_ID: '/search-quote/:quoteKey',
  SEARCH_QUOTE_ID_HISTORY: '/search-quote/:quoteKey/history',
  SEARCH_QUOTE_CREATE: '/search-quote/create',
  ADD_SHIPMENT: '/shipment/add',
  VISIBILITY: '/visibility',
  CLAIMS: '/claims',
  PROCUREMENT: '/procurement',
  ADD_PROJECT_PROCUREMENT: '/procurement/add-project',
  ADD_TENDER_PROCUREMENT: '/procurement/add-tender',
  FREIGHT_BILL: '/freight-bill',
  ADMIN_SETTINGS: '/admin-settings',
  PURCHASE_ORDER_VIEW: '/purchase-order-view',
  PURCHASE_ORDER_MANAGEMENT: '/purchase-order-management',
  PURCHASE_ORDER_MANAGEMENT_ID: '/purchase-order-management/:shipmentKey',
  CREATE_SHIPMENT: '/create-shipment',
  COMPANY_SETTINGS: '/manage-company',
  CREATE_SHIPMENT_ID: '/create-shipment/:shipmentKey',
  TMS_SETTINGS: '/settings/tms-settings',
  AUCTION: '/auction',
  SETTINGS: '/settings',
  SHIPMENT_GET_QUOTE: '/shipment/get-quote',
  SHIPMENT_GET_QUOTE_FOR_MAIN: '/get-quote',
  SHIPMENT_PARCEL_EXPRESS: '/shipment/parcel-express',
  SHIPMENT_NOTIFICATION_ROUTING: '/shipment/notification-routing',
  PURCHASE_ORDER_VENDOR_SEARCH: '/purchase-order-management/vendor-search',
  PURCHASE_ORDER_SHIPMENT_SEARCH: '/purchase-order-management/shipment-search',
  PURCHASE_ORDER_DRAFT_SEARCH: '/purchase-order-management/draft-search',
  PURCHASE_ORDER_PRE_BOOKING_SEARCH: '/purchase-order-management/pre-booking-search',
  PURCHASE_ORDER_PARCEL_EXPRESS: '/parcel-express/:shipmentNumber',
  PURCHASE_ORDER_ROUTING_GUIDE: '/purchase-order-management/routing-guide',

  RATE_SHOP: '/rate-shop',
  PROCUREMENT_PROJECT: '/procurement/project',
  PROCUREMENT_TENDER: '/procurement/tender',
  PROCUREMENT_BID_ANALYSIS: '/procurement/bid-analysis',
  PROCUREMENT_ROUTE_CONFIG: '/procurement/route-config',
  PROCUREMENT_ROUTE_CONFIG_LOCATION: '/procurement/route-config/location',
  ADD_LANE: '/procurement/route-config/lane/add',
  ROUTING_GUIDE: '/routing-guide',
  NXP_ROUTING_GUIDE: '/routing-guide/nxp',
  ROUTING_GUIDE_USER: '/routing-guide/user',
  ADD_ROUTING_GUIDE: '/routing-guide/add-routing-guide',
  ADD_NXP_USER: '/routing-guide/add-user',
  PRE_CLAIMS: '/claims/pre',
  OVERCHARGE_CLAIMS: '/claims/over-charge',
  LOSS_AND_DAMAGE_CLAIMS: '/claims/loss-damage',
  CREATE_LOSS_AND_DAMAGE_CLAIMS: '/claims/loss-damage/create',
  CLAIMS_REPORTS: '/claims/reports',
  CLAIMS_SETTINGS: '/claims/settings',
  OVERCHARGE_CLAIMS_CREATE: '/claims/over-charge/create',
  QUOTE_DETAILS: '/quotedetails',
  HAL_ROUTING_GUIDE: '/Hal-routing-guide',

  SAVERS_HOME_MAIN: '/savers-home',
  SAVERS_SUPPLYZONE_MAIN: '/supply-zone',
  SAVERS_LOCATIONS_MAIN: '/locations',
  SAVERS_TRAILERDATABASE_MAIN: '/trailer-database',
  SAVERS_HOME: '/savers/savers-home',
  SAVERS_SUPPLYZONE: '/savers/supply-zone',
  SAVERS_LOCATIONS: '/savers/locations',
  SAVERS_TRAILERDATABASE: '/savers/trailer-database',
  SAVERS_SHIPMENT: '/savers/saver-shipment',
  SAVERS: '/savers',
  ERROR: '/error',
} as const;

export const API_APP_ROUTES = {
  Dashboard: APP_ROUTES.DASHBOARD,
  iShipment: APP_ROUTES.SHIPMENT,
  PO: APP_ROUTES.PURCHASE_ORDER_VIEW,
  POV: APP_ROUTES.PURCHASE_ORDER_MANAGEMENT,
  TMSSettings: APP_ROUTES.TMS_SETTINGS,
  Auction: APP_ROUTES.AUCTION,
  Settings: APP_ROUTES.SETTINGS,
  iVisibility: APP_ROUTES.VISIBILITY,
  'iVisibility for Cust': APP_ROUTES.VISIBILITY,
  'Visibility for Vendor': APP_ROUTES.VISIBILITY,
  iProcurement: APP_ROUTES.PROCUREMENT,
  ProcurementProject: APP_ROUTES.PROCUREMENT,
  ProcurementTender: APP_ROUTES.PROCUREMENT_TENDER,
  BidAnalysis: APP_ROUTES.PROCUREMENT_BID_ANALYSIS,
  RouteConfiguration: APP_ROUTES.PROCUREMENT_ROUTE_CONFIG,
  RateShop: APP_ROUTES.RATE_SHOP,
  RoutingGuide: APP_ROUTES.ROUTING_GUIDE,
  RoutingGuideHome: APP_ROUTES.NXP_ROUTING_GUIDE,
  RoutingGuideUser: APP_ROUTES.ROUTING_GUIDE_USER,
  iClaims: APP_ROUTES.LOSS_AND_DAMAGE_CLAIMS,
  ShipmentGetQuote: APP_ROUTES.SHIPMENT_GET_QUOTE_FOR_MAIN,
  SearchQuote: APP_ROUTES.SEARCH_QUOTE,
  SearchQuoteId: APP_ROUTES.SEARCH_QUOTE_ID,
  GetQuote: APP_ROUTES.QUOTE_DETAILS,
  QuoteDashboard: APP_ROUTES.DASHBOARD,
  CarrQuoteDashboard: APP_ROUTES.CarrQuoteDashboard,
  CarrierRegistration: APP_ROUTES.CARRIER_REGISTRATION,
  QuoteRoutingGuide: APP_ROUTES.HAL_ROUTING_GUIDE,
  TrailerManagement: APP_ROUTES.SAVERS,
} as const;

export const ACTION_NEEDED_ROUTES = {
  BASE: '/action-needed',
  SHIPMENT_APPROVAL_REJECTION: '/shipment/approval-rejection',
} as const;
